import CatEventForm from 'components/features/cat-event-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function CreateCatEvent() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('catEvent.createCatEvent')}>
      <CatEventForm />
    </HomeLayout>
  );
}

export default CreateCatEvent;
